import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ fullScreen = false, size = "md", label }) => (
  <div className={`loading-spinner-container ${fullScreen ? "full-screen" : ""}`}>
    <div className={`loading-spinner ${size}`}>
      <div className="spinner-ring" />
    </div>
    {label && <span className="loading-label">{label}</span>}
  </div>
);

export default LoadingSpinner;
